import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface MainContentProps {
  children: React.ReactNode;
  onMobileMenuOpen?: () => void;
}

export const MainContent: React.FC<MainContentProps> = ({
  children,
  onMobileMenuOpen,
}) => {
  const theme = useTheme();

  return (
    <Box
      component="main"
      sx={{
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        bgcolor: theme.palette.background.paper,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </Box>
  );
};
